import Vue from 'vue';
import Router from 'vue-router';
import BaremeHome from '@/components/bareme/BaremeHome.vue';
import BaremeResultat from '@/components/bareme/BaremeResultat.vue';
import BaremeAjuste from '@/components/bareme/BaremeAjuste.vue';
import BaremeAjusteResultat from '@/components/bareme/BaremeAjusteResultat.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/prelevement/etape1',
      name: 'routePrelevementEtape1',
      title: 'Formulaire Prélèvement',
      meta: { layout: 'default' },
      component: BaremeHome,
    },
    {
      path: '/prelevement/etape2',
      name: 'routePrelevementEtape2',
      meta: { layout: 'default' },
      component: BaremeResultat,
    },
    {
      path: '/prelevement/etape3',
      name: 'routePrelevementEtape3',
      meta: { layout: 'default' },
      component: BaremeAjuste,
    },
    {
      path: '/prelevement/etape4',
      name: 'routePrelevementEtape4',
      props: true,
      meta: { layout: 'default' },
      component: BaremeAjusteResultat,
    },
    {
      path: '/',
      redirect: '/prelevement/etape1',
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
